import { OptionModel } from './optionModel';

export class DialogData {
  selectNode!: OptionModel;
  items: Array<any> = [];
  title!: string;
  showRoot: boolean = false;
  content!: string;
  substance!: number;
  canChooseRoot: boolean = false;
  locations!: number;
  rootName!: string;
  sublevel!: number;
  isGuidId = true;
  isMultiSelect: boolean = false;
  isIncludeChildData!: boolean;
  selectedIds: string[] = [];
  filterLocationByIds?: string[];
  currentPageIndex?: number;
}
